import { memo } from 'react';
import { Link } from '@appsumo/dorado-react';
import Image from 'next/image';

import VerifiedUserBadge from '~/public/verified-user-badge.png';

export type FTFPostAuthorProps = {
  avatar: string;
  displayName: string;
  username: string;
  emailVerified: boolean;
  title: string;
};

export default memo(function FTFPostAuthor({
  avatar,
  displayName,
  username,
  emailVerified,
  title,
}: Readonly<FTFPostAuthorProps>) {
  return (
    <div className="flex items-center gap-x-4">
      <div className="relative">
        <Image
          src={avatar}
          alt="Post author"
          unoptimized
          width={48}
          height={48}
          className="h-12 w-12 rounded-full object-cover"
        />
        {emailVerified && (
          <span className="absolute bottom-[-3px] right-[-10px] rounded-full p-1">
            <Image
              src={VerifiedUserBadge}
              alt="Verified user"
              height={20}
              width={20}
              className="h-5 w-5"
            />
          </span>
        )}
      </div>
      <div className="flex flex-row items-center">
        <Link
          href={`/profile/${username}/`}
          className="text-bolt"
          styled
          target="_blank"
        >
          {displayName}
        </Link>
        {title && (
          <>
            &#44; &nbsp;
            <p className="text-grace">{title}</p>
          </>
        )}
      </div>
    </div>
  );
});
